import React, { useRef, useEffect } from "react";
import * as S from "./LeadGenThankU.styles";

const LeadGenThankU = (props) => {

    return (
        <S.QueryFormContainer>
            <div className="outer">
                <div className="contactManagementContainer">
                    <div className="contactManagementHdr">
                        <p className="closePopup" onClick={() => props.onClose()}></p>
                    </div>
                    <div className="contactManagementForm">
                        <div className="makeFlex flexWrap column textCenter appendTop15">
                            <p className="tnkU">
                                <span className="makeFlex hrtlCenter vrtlCenter yellowCircle">
                                    <span className="holidaySprite icon48 thankYou"></span>
                                </span>
                            </p>
                            {
                                props.content ? 
                                    <>
                                        <p className="thankYou">{props.content}</p>
                                        <p className="thankYouMsg">Our team will get in touch with a tailor-made deal especially for you.</p>
                                    </>
                                : <p className="thankYou">Submitting...</p>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </S.QueryFormContainer>
    )
}

export default LeadGenThankU